import {
  ADD_PRODUCT_ID,
  ADD_CONTEXT,
  ADD_FOLDER_ID,
  LOAD_BOOK_CONTEXT,
  ADD_DEFAULT_TEXT,
  ADD_PARENT_STYLE,
  LOAD_PARENT_STYLE,
} from './../../action-types/bookproperties';

export const addBookId = productID => ({
  type: ADD_PRODUCT_ID,
  productID,
});

export const addContext = context => ({
  type: ADD_CONTEXT,
  context,
});

export const addFolderId = folderId => ({
  type: ADD_FOLDER_ID,
  folderId,
});

export const loadBookContext = context => ({
  type: LOAD_BOOK_CONTEXT,
  context,
});

export const addDefaultText = text => ({
  type: ADD_DEFAULT_TEXT,
  text,
});

export const addParentStyle = style => ({
  type: ADD_PARENT_STYLE,
  style,
});

export const loadParentStyle = style => ({
  type: LOAD_PARENT_STYLE,
  style,
});



// WEBPACK FOOTER //
// ./src/redux/actions/bookproperties/index.js